<template>
   <div class="container px-0 bg-danger">
      <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
            data-bs-scroll="true" 
            data-bs-backdrop="false" 
            tabindex="-1" 
            id="offcanvasMembers" 
            aria-labelledby="offcanvasMembersLabel"
            @blur="focusOff()"
         >
         <!--
            @blur="focusOff()"
         -->
         <div class="offcanvas-header">
            <h6 id="offcanvasMembersLabel">Miembros ({{cnttId}})</h6>
            <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
         </div>
         <hr class="m-0"/>
         <div class="offcanvas-body gap-0 pt-2 mb-scroll">
            <div class="row pb-2">
               <b class="tc-d-gray fs-12">Miembros sin participar:</b>
            </div>
            <div class="row row-cols-auto ps-2">
               <div v-for="(circleUser, index) in usersOut" :key="index" class="col p-0 m-1">
                  <userCircle :circleUser="circleUser" @click="userYes(index)" class="user-member"/>
               </div>
            </div>
            <div class="row py-2">
               <b class="tc-d-gray fs-12">Miembros convocados a participar:</b>
            </div>
            <div class="row row-cols-auto ps-2">
               <div v-for="(userToAdd, index) in usersToAdd" :key="index" class="col p-0 m-1">
                  <userCircle :circleUser="userToAdd" @click="userNo(index)" class="user-member"/>
               </div>
            </div>
            <div v-if="usersToAdd.length > 0" class="row px-1">
               <div v-if="loading" class="fp-onOff btn-info rounded mt-2">
                  <span class="spinner-border spinner-border-sm"></span>
                  Participando miembros
               </div>
               <div v-else class="fp-onOff btn-info rounded mt-2" @click="addMembers()">
                  Participar miembros
               </div>
            </div>
         <!--
            <div v-if="loading" class="btt-attach btn-save rounded">
               <span class="spinner-border spinner-border-sm"></span>
               Adjuntando archivo
            </div>
            <div v-else class="btt-attach btn-save rounded" @click="upload">
               Adjuntar
            </div>
         -->
         </div>
      </div>
   </div>
</template>

<script>
//import { ref, nextTick, watchEffect } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

import userCircle from '/src/components/UserCircle.vue';

export default {
   components: {
      userCircle
   },
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const btn_out_offcanvas = ref(null)
      const cellId = ref(0)
      const boardId = ref(null)

      const loading = ref(false)
      const usersOut = ref([])
      const usersToAdd = ref([])
      const userIdsToAdd = ref([])
      const uAppIndex = ref(-1)
      const uAppModule = ref(null)


      onMounted(() => {
         //
         let myOffCanvas = document.getElementById('offcanvasMembers')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
            console.log(store.state.wspace.contentId)
            cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            //
            boardId.value = WspService.getBoardId(store)
            getUsersOut(cnttId.value)
            usersToAdd.value = []
            uAppIndex.value = -1
            userIdsToAdd.value = []
            loading.value = false
            //
            myOffCanvas.focus()
            console.log(" show member's OC")
         })
         //
         console.log("member's OC")
      })

      function getUsersOut(contentId) {
         uAppIndex.value = store.state.auth.userAppIndex
         if (uAppIndex.value > -1) {
            uAppModule.value = store.state.auth.userAppModule;

            WspService.getMembersNotInCard(
               uAppModule.value.appModuleComponent[uAppIndex.value].userAppModuleId,
               contentId,
               boardId.value
               )
            .then(response => {
               usersOut.value = response.data
               //console.log(response.data)
            })
            .catch(error => {
               console.log(error);
            });
         }
      }

      function addMembers() {
         loading.value = true
         userIdsToAdd.value = []
         usersToAdd.value.forEach(function (user) {
            let addIndex = userIdsToAdd.value.length
            userIdsToAdd.value.splice(addIndex,0,user.id)
         });

            WspService.addMembersToCard(
               userIdsToAdd.value,
               cnttId.value,
               store.state.auth.user.id,     // userId,
               cellId.value,
               boardId.value
               )
            .then(() => {
               store.dispatch("wspace/setContentId", -9)
               focusOff()
            })
            .catch(error => {
               loading.value = false
               console.log(error);
            });
      }

      function userNo(index) {
         let removed = usersToAdd.value.splice(index, 1)
         let addIndex = usersOut.value.length
         usersOut.value.splice(addIndex,0,removed[0])
      }

      function userYes(index) {
         let removed = usersOut.value.splice(index, 1)
         let addIndex = usersToAdd.value.length
         usersToAdd.value.splice(addIndex,0,removed[0])
      }

      function focusOff() {
         //
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            console.log(timer)
            loading.value = false
            btn_out_offcanvas.value.click()
            console.log(timer)
         }             
         }, 125)
         //
      }

      return {
         addMembers,
         btn_out_offcanvas,
         focusOff,
         cellId,
         cnttId,
         loading,
         uAppIndex,
         uAppModule,
         usersOut,
         userIdsToAdd,
         usersToAdd,
         userNo,
         userYes
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 50px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.user-member:hover {
   cursor: pointer;
}
.mb-scroll {
   max-height: calc(100vh - 130px);
   overflow: auto;
}
</style>